<template>
  <div v-if="isSelf || isCompanyContact" class="text-center">
    <GuTooltip>
      <template #trigger>
        <i class="bx" :class="isSelf ? 'bx-user' : 'bx-buildings'" />
      </template>
      {{
        isSelf
          ? 'This address is part of your account information'
          : 'This address is shared with your company'
      }}
    </GuTooltip>
  </div>
</template>

<script setup>
import { toRefs, computed } from 'vue'
import { GuTooltip } from '@shared/gu-components/tooltip'

const props = defineProps({
  params: {
    type: Object,
    default: () => ({}),
  },
})
const { params } = toRefs(props)

const isSelf = computed(() => {
  return params.value.data.id === -1
})

const isCompanyContact = computed(() => {
  return params.value.data.isCompany
})
</script>
